import { render, staticRenderFns } from "./RoleUpdate.vue?vue&type=template&id=1aee62bd&scoped=true"
import script from "./RoleUpdate.vue?vue&type=script&lang=js"
export * from "./RoleUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee62bd",
  null
  
)

export default component.exports